import API from '../../../lib/api'

const NOT_FOUND_ERROR_CODES = [400, 404]

export const getCouponTemplateDetails = async (templateCode) => {
  try {
    const couponAPI = new API({
      url: `/rms/coupon-templates`,
    })
    const response = await couponAPI.get({ templateCode })

    if (!response) {
      throw new Error('No response received')
    }

    const result = response.result?.[0] ?? response.data?.result?.[0]
    if (!result) {
      return {
        couponTitle: '',
        couponDescription: '',
        validStartTime: '',
        validEndTime: '',
        maxClaimPerUser: 0,
        couponError: `This coupon template code ${templateCode} cannot be found.`,
      }
    }

    return {
      couponTitle: result.displayName ?? '',
      // DSP leaves displayDescription empty on most templates, so the
      // Description field reads displayName until DSP fills it in
      couponDescription: result.displayName ?? '',
      validStartTime: result.validStartTime ?? '',
      validEndTime: result.validEndTime ?? '',
      maxClaimPerUser: Number(result.maxClaimPerUser) || 0,
      couponError: '',
    }
  } catch (error) {
    const couponError = NOT_FOUND_ERROR_CODES.includes(error.code)
      ? `This coupon template code ${templateCode} cannot be found.`
      : error.message || 'Failed to look up coupon template.'
    return {
      couponTitle: '',
      couponDescription: '',
      validStartTime: '',
      validEndTime: '',
      maxClaimPerUser: 0,
      couponError,
    }
  }
}
